import * as React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Card, CardContent, PageHeader } from '@klareospace/pharos-lib-web-utils';

import { MainSelector } from '&/features/main-selector';
import { CustomerDrawer, CustomersActionBar, CustomersTable } from '../components';
import { useCustomersPage } from '../hooks';

// ─── Page ─────────────────────────────────────────────────────────────────────

export function CustomersPage(): React.JSX.Element {
  const { t: tCommon } = useTranslation('common');
  const pageState = useCustomersPage();
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (pageState.error) {
    throw pageState.error;
  }

  function handleCreateClick(): void {
    setDrawerOpen(true);
  }

  function handleDrawerClose(): void {
    setDrawerOpen(false);
  }

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <PageHeader breadcrumb={<MainSelector />} title={tCommon('navigation.customers')} variant="banner" />
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden px-6 pb-6 pt-4">
        <div className="flex min-h-0 flex-1 flex-col gap-4">
          <CustomersActionBar
            onCreateClick={handleCreateClick}
            onScopeFilterChange={pageState.onScopeFilterChange}
            onSearchChange={pageState.onSearchChange}
            onStatusFilterChange={pageState.onStatusFilterChange}
            onTypeFilterChange={pageState.onTypeFilterChange}
            scopeFilter={pageState.scopeFilter}
            searchValue={pageState.searchValue}
            statusFilter={pageState.statusFilter}
            typeFilter={pageState.typeFilter}
          />
          <Card className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl shadow-sm">
            <CardContent className="flex min-h-0 flex-1 flex-col p-0">
              <CustomersTable
                customers={pageState.customers}
                isLoading={pageState.isLoading}
                pagination={{
                  currentPage: pageState.currentPage,
                  onPageChange: pageState.onPageChange,
                  onPageSizeChange: pageState.onPageSizeChange,
                  pageSize: pageState.pageSize,
                  pageSizeOptions: pageState.pageSizeOptions,
                  totalItems: pageState.totalItems,
                  totalPages: pageState.totalPages,
                }}
                sorting={{
                  onSort: pageState.onSort,
                  sortBy: pageState.sortBy,
                  sortDirection: pageState.sortDirection,
                }}
              />
            </CardContent>
          </Card>
        </div>
      </div>
      <CustomerDrawer customer={null} onClose={handleDrawerClose} open={drawerOpen} />
    </div>
  );
}
